// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"c76cdef2","104":"e0443333","297":"9646ae18","534":"2b91e554","774":"571ecee2"}[chunkId] + ".css";
};